export var clientConfig = {
    concurrency: 10,
    lowConcurrency: 1,
    mediumConcurrency: 5,
    lookalikeConcurrency: 10,
    dummy: null,
    callWait: 1000,
    colors: {
        "odd": "#EFF9FB",
        "even": "#F5F5DC"
    },
    defaultRowHeight: 15,
    defaultColumnWidth: 150,
    enhanceUrl: "https://kg.diffbot.com/kg/v3/enhance_endpoint?nonCanonicalFacts=true&useCache=false",
    dqlUrl: "https://kg.diffbot.com/kg/v3/dql?type=query&nonCanonicalFacts=true",
    accountApi: "https://api.diffbot.com/v3/account",
    usersBotApi: "https://users.diffbot.com",
    diffbotPricingPage: "https://www.diffbot.com/pricing/",
    gettingStartedVideos: {
        overview: "https://www.youtube.com/embed/mdFvwzPWNXo?autoplay=1&vq=hd720",
        newsMonitoring: "https://www.youtube.com/embed/O_9bsOtqkxs?autoplay=1&vq=hd720",
        marketIntelligence: "https://www.youtube.com/embed/4oTdbVSEZZs?autoplay=1&vq=hd720",
        dataEnrichment: "https://www.youtube.com/embed/lbG5fl5foD8?autoplay=1&vq=hd720",
        leadGeneration: "https://www.youtube.com/embed/_G_feBvk-lY?autoplay=1&vq=hd720"
    },
    tutorialPage: "https://docs.diffbot.com/docs/en/dql-excel",
    dqlChunks: {
        organization: 100,
        person: {
            small: 5,
            big: 25
        },
        article: 10
    },
    diffbotToken: null,
    ajaxTimeout: 500000,
    numberOfTries: 5,
    sampleInputSheetName: "Input sheet - example",
    organizationInputSheetName: "Org input sheet - example",
    personInputSheetName: "Person input sheet - example",
    organizationsSampleOutputSheetName: "Organization output - example",
    personsSampleOutputSheetName: "Person output - example",
    appEndpoint: window.location.hostname === "localhost" ? "https://localhost:3005/" : window.location.hostname.indexOf("staging") > 0 ? "https://diffbot-excel-add-in-staging.herokuapp.com/" : "https://excel.diffbot.com/",
    ajaxHeaders: {
        "X-Diffbot-App": "excel"
    },
    searchDialog: {
        maximumItemsAllowed: 200
    },
    supportedDataTypes: ["Organization", "Person", "Article"],
    defaultNumberOfEntities: "1000"
};